import { Mail, Phone, MapPin, Linkedin } from "lucide-react";
import { FadeUp, SectionTag } from "../components/site/Reveal";
import { ContactForm } from "../components/site/ContactForm";
import { CONTACT_EMAIL, PHONE, LINKEDIN_URL } from "../content";

export default function Contact() {
  return (
    <main data-testid="contact-page" className="pt-24">
      <section className="mx-auto max-w-7xl px-6 py-20 lg:px-10">
        <div className="grid items-start gap-16 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <FadeUp>
              <SectionTag>Contact</SectionTag>
              <h1 className="mt-4 font-serif text-4xl font-bold tracking-tight text-ink sm:text-5xl">
                Start the <span className="gold-text italic">conversation</span>
              </h1>
              <p className="mt-6 max-w-md text-base leading-relaxed text-slate-600">
                Raising, scaling, entering, or exiting: tell Roy what you are trying to
                win. Your message lands directly in his inbox and gets a direct reply.
              </p>
            </FadeUp>
            <FadeUp delay={0.12}>
              <div className="mt-10 space-y-5 border border-gold/25 bg-white p-8 text-sm">
                <a
                  data-testid="contact-email-link"
                  href={`mailto:${CONTACT_EMAIL}`}
                  className="flex items-center gap-3 text-slate-700 transition-colors hover:text-golddeep"
                >
                  <Mail size={16} className="text-golddeep" /> {CONTACT_EMAIL}
                </a>
                <a
                  data-testid="contact-phone-link"
                  href="tel:+19044109000"
                  className="flex items-center gap-3 text-slate-700 transition-colors hover:text-golddeep"
                >
                  <Phone size={16} className="text-golddeep" /> {PHONE}
                </a>
                <a
                  data-testid="contact-linkedin-link"
                  href={LINKEDIN_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-slate-700 transition-colors hover:text-golddeep"
                >
                  <Linkedin size={16} className="text-golddeep" /> linkedin.com/in/roybuncome
                </a>
                <p className="flex items-center gap-3 text-slate-500">
                  <MapPin size={16} className="text-golddeep" /> Jacksonville, Florida
                </p>
              </div>
            </FadeUp>
          </div>
          <FadeUp delay={0.15} className="lg:col-span-3">
            <div className="border border-gold/25 bg-cream p-8 sm:p-10">
              <ContactForm />
            </div>
          </FadeUp>
        </div>
      </section>
    </main>
  );
}
